// Trailing debounce where every awaiting caller resolves with the final call's
// result, so suppressed calls don't settle to `undefined` and break TipTap's
// `items()` list render.
export const debouncePromise = <A extends unknown[], R>(fn: (...args: A) => Promise<R>, ms: number) => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let pending: { resolve: (value: R) => void; reject: (error: unknown) => void }[] = [];

  return (...args: A): Promise<R> =>
    new Promise<R>((resolve, reject) => {
      pending.push({ resolve, reject });
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        const waiters = pending;
        pending = [];
        timer = undefined;
        fn(...args).then(
          value =>
            waiters.forEach(w => {
              w.resolve(value);
            }),
          error =>
            waiters.forEach(w => {
              w.reject(error);
            }),
        );
      }, ms);
    });
};
